import 'bootstrap/js/src/collapse'
import 'bootstrap/js/src/dropdown'
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.js'
import '../Gallery/Scripts'

import './Styles.scss'

const scroll = new SmoothScroll('[data-scroll]', {
	speed: 1000,
	offset: function (anchor, toggle) {
		return 59
	}
})

// Common blocks and components
import '../../Blocks/Header/Scripts'
import '../../Blocks/Footer/Scripts'
import '../../Blocks/MainPosts/Scripts'

import '../../Components/Breadcrumb/Scripts'
import '../../Components/Pagination/Scripts'
import '../../Components/PostHeader/Scripts'
import '../../Components/TagsGroup/Scripts'
import '../../Components/CategoriesGroup/Scripts'
import '../../Components/PreferredSource/Scripts'
import '../../Components/SocialBox/Scripts'
import '../../Components/PostNavigation/Scripts'
import '../../Components/AuthorBox/Scripts'
import '../../Components/SeznamRecommendedPosts/Scripts'
import '../../Components/RelatedPosts/Scripts'
import '../../Components/Comments/Scripts'
import '../../Components/PostContent/Scripts'
import { onloadDiscussionScript } from '../../Components/Discussion/Scripts'

import { poll_vote, poll_result, poll_booth } from '../../Widgets/Polls/Scripts'
import '../../Widgets/PostsTabs/Scripts'
import '../../Widgets/LatestComments/Scripts'
import '../../Widgets/PopularPosts/Scripts'
import '../../Widgets/RssPosts/Scripts'
import '../../Widgets/FacebookPageBox/Scripts'
import '../../Widgets/SocialBox/Scripts'

export { onloadDiscussionScript, poll_vote, poll_result, poll_booth }
